<!-- 导购员名单 -->
<template>
    <div class="container">
        <div class="lefter">
            <Button
                class="theme-bc mt12 mb24 ml12"
                icon="md-add-circle"
                type="warning"
                @click="goAddCategory"
                >新增分类</Button
            >
            <div class="card-container">
                <div
                    :class="category_value == index ? 'card-active' : 'card'"
                    v-for="(item, index) of type_list"
                    :key="index"
                    @click="activeCategory(index, item)"
                >
                    <div>{{ item.name }}</div>
                    <div class="category-right">
                        <div>{{ item.sort }}</div>
                        <img
                            src="@/assets/diy_input.png"
                            class="help-add-icon"
                            @click.stop="goAddCategory(item)"
                        />
                        <img
                            src="@/assets/delete.png"
                            class="help-del-icon"
                            @click.stop="goDelCategory(item)"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="content">
            <Button
                class="theme-bc mb24"
                icon="md-add-circle"
                type="warning"
                @click="goAddModal"
                >新增导购员</Button
            >
            <Table :columns="columnsTable" :data="dataTable" border>
                <template slot-scope="{ row }" slot="name">
                    <div>{{ row.customer ? row.customer.name : "" }}</div>
                </template>
                <template slot-scope="{ row }" slot="phone">
                    <div>{{ row.customer ? row.customer.phone : "" }}</div>
                </template>
                <template slot-scope="{ row }" slot="operate">
                    <Button type="error" ghost label="small" @click="goDel(row)"
                        >删除</Button
                    >
                </template>
            </Table>
            <div class="text-align-right mt24">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>

        <!-- 新增/编辑 -->
        <Modal
            v-model="add_modal"
            title="新增导购员"
            width="500"
            :mask-closable="false"
        >
            <Form
                :model="form_item"
                label-position="right"
                :label-width="100"
                class="mt24"
            >
                <FormItem label="选择导购员：">
                    <Select
                        class="w300"
                        v-model="form_item.customer_id"
                        clearable
                        filterable
                        placeholder="请选择导购员"
                    >
                        <Option
                            v-for="item in customerList"
                            :value="item.id"
                            :key="item.id"
                            :label="`${item.name} ${item.phone}`"
                        />
                    </Select>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button class="theme-bc" type="warning" @click="submitModal"
                    >确认</Button
                >
            </div>
        </Modal>
        <!-- 新增分类/编辑分类 -->
        <Modal
            v-model="add_category_modal"
            :title="add_category_modal_title"
            width="500"
            :mask-closable="false"
        >
            <Form
                :model="form_category_item"
                label-position="right"
                :label-width="100"
                class="mt24"
            >
                <FormItem label="分类名称：">
                    <Input
                        class="w300"
                        type="text"
                        v-model="form_category_item.name"
                        placeholder="请输入分类名称"
                    ></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelCategoryModal">取消</Button>
                <Button
                    class="theme-bc"
                    type="warning"
                    @click="submitCategoryModal"
                    >确认</Button
                >
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    shopping_list,
    shopping_save,
    shopping_delete,
    shopping_type,
    shopping_type_save,
    shopping_type_delete,
    customer_select,
} from "@/api/index";
import editor from "@/components/editor/editor.vue";
export default {
    components: { editor },
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 30,
                type_id: -1,
            },
            total: 0,
            columnsTable: [
                { type: "index", width: 60, align: "center" },
                { title: "用户名称", slot: "name", align: "center" },
                { title: "手机号", slot: "phone", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "100px",
                },
            ],
            dataTable: [],
            add_modal: false,
            form_item: {
                type_id: -1,
                customer_id: "",
            },
            type_list: [],
            category_value: 0,
            add_category_modal: false,
            add_category_modal_title: "",
            form_category_item: {
                id: "",
                name: "",
            },
            customerList: [],
        };
    },
    mounted() {
        this.getShoppingType();
        this.getProductSelect();
    },
    methods: {
        // 用户下拉列表
        getProductSelect() {
            customer_select()
                .then((res) => {
                    this.customerList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getShoppingType() {
            shopping_type().then((res) => {
                this.storePrams.type_id = res.data.data[0].id;
                this.form_item.type_id = res.data.data[0].id;
                this.type_list = res.data.data;
                this.getList();
            });
        },
        getList() {
            shopping_list(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        goAddModal() {
            this.form_item.customer_id = "";
            setTimeout(() => {
                this.add_modal = true;
            }, 300);
        },
        // 确定
        submitModal() {
            shopping_save(this.form_item)
                .then((res) => {
                    this.getList();
                    this.add_modal = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        cancelModal() {
            this.add_modal = false;
        },
        goDel(row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？",
                onOk: () => {
                    shopping_delete({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        activeCategory(index, item) {
            this.category_value = index;
            if (item) {
                this.storePrams.type_id = item.id;
                this.form_item.type_id = item.id;
            }
            setTimeout(() => {
                this.getList();
            }, 300);
        },
        goAddCategory(item) {
            if (item.id) {
                this.add_category_modal_title = "编辑分类";
                this.form_category_item.id = item.id;
                this.form_category_item.name = item.name;
            } else {
                this.add_category_modal_title = "新增分类";
                this.form_category_item.id = "";
                this.form_category_item.name = "";
            }
            setTimeout(() => {
                this.add_category_modal = true;
            }, 300);
        },
        // 确定
        submitCategoryModal() {
            shopping_type_save(this.form_category_item)
                .then((res) => {
                    this.getShoppingType();
                    this.add_category_modal = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        cancelCategoryModal() {
            this.add_category_modal = false;
        },
        goDelCategory(item) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？",
                onOk: () => {
                    shopping_type_delete({ id: item.id })
                        .then((res) => {
                            this.getShoppingType();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
    },
};
</script>

<style scoped>
.container {
    width: 100%;
    display: flex;
    flex-direction: row;
}
.lefter {
    padding: 12px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    width: 30%;
    border-right: 1px solid #eee;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    width: 70%;
}
.text-align-right {
    text-align: right;
}
.card-container {
    width: 100%;
}
.card-active {
    padding: 10px;
    background: #e8eaf4;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    cursor: pointer;
}
.card {
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #666666;
    cursor: pointer;
}
.category-right {
    margin-left: 24px;
    display: flex;
    align-items: center;
}
.help-add-icon {
    margin-left: 24px;
    min-width: 14px;
    width: 14px;
    min-height: 14px;
    height: 14px;
}
.help-del-icon {
    margin: 0 2px 0 12px;
    min-width: 20px;
    width: 20px;
    min-height: 20px;
    height: 20px;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>